/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_DescInputs */

const en_directory_submit_badge_desc = /** @type {(inputs: Directory_Submit_Badge_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add our badge to your product website, then verify it here. Once confirmed, your listing gets a dofollow link at no extra cost.`)
};

const zh_directory_submit_badge_desc = /** @type {(inputs: Directory_Submit_Badge_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将我们的徽章放到产品网站上，再在这里验证。确认后，你的条目将免费获得 dofollow 外链。`)
};

/**
* | output |
* | --- |
* | "Add our badge to your product website, then verify it here. Once confirmed, your listing gets a dofollow link at no extra cost." |
*
* @param {Directory_Submit_Badge_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_desc = /** @type {((inputs?: Directory_Submit_Badge_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_desc(inputs)
	return zh_directory_submit_badge_desc(inputs)
});
export { directory_submit_badge_desc as "directory.submit.badge_desc" }